// Abu Dhabi - freelance personal trainer. Client-facing; no trainer list.
const content = {
    slug: 'freelance-personal-trainer',
    title: 'Freelance Personal Trainer in Abu Dhabi | What to Know',
    description: (c) =>
        `Hiring a freelance personal trainer in Abu Dhabi: benefits, the checks to make, and package prices from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Abu Dhabi · Freelance trainer',
    h1: 'Freelance Personal Trainer in Abu Dhabi',
    lead: 'Abu Dhabi homes are spread out, from the island to Khalifa City and beyond. A freelance trainer who drives to you saves you the commute to a gym - and fits sessions into the gaps in your day.',
    image: 'personal-trainer/fitness-model-couple.png',
    imageAlt: 'Personal trainer and client after a training session',
    facts: ['Comes to your home', 'Flexible timing', 'Checked credentials'],
    matchSummary: 'a freelance personal trainer in Abu Dhabi',
    trainerCta: true,
    packagesTitle: 'Packages',
    sections: [
        {
            title: 'Why hire a freelance trainer here',
            cards: [
                { title: 'No commute', body: 'In a city where most journeys are by car, training at home saves you a drive and parking.' },
                { title: 'Your hours', body: 'Early mornings, after work or during the children\'s school hours.' },
                { title: 'Your space', body: 'Villa, compound gym, building gym or a park in the cooler months.' },
            ],
        },
        {
            title: 'Checks worth making',
            tone: 'muted',
            items: [
                'A recognised personal training certification.',
                'Registration on REPs UAE.',
                'The right permit or licence to work freelance in the UAE.',
                'First aid and CPR.',
                'Written package terms covering cancellations and travel.',
            ],
        },
        {
            title: 'Why book through StringsSG',
            paragraphs: [
                'We verify credentials before a trainer joins, set fixed package prices, and stay involved: scheduling, payment and a replacement trainer if it doesn\'t work out. You get a freelance trainer\'s flexibility with someone accountable behind them.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Do freelance trainers need a licence in Abu Dhabi?',
            answer: 'Yes - working freelance in the UAE requires the appropriate permit or licence, and REPs UAE registration is the industry standard.',
        },
        {
            question: 'How much does a freelance personal trainer cost in Abu Dhabi?',
            answer: (c) => `From ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session with StringsSG.`,
        },
        {
            question: 'I am a freelance trainer in Abu Dhabi - can I join?',
            answer: 'Yes, apply using the founding trainer link on this page.',
        },
    ],
    schema: { name: 'Freelance Personal Trainer in Abu Dhabi' },
}

export default content
